module.exports = __webpack_public_path__ + "static/media/glasses-alt.a2ca3694.svg";